<!-- 本科home页 -->
<template>
  <div class='main-container'>
    <home-header></home-header>
    <div class="home-main-con">
      <router-view></router-view>
    </div>
    <home-footer></home-footer>
    <div v-if='hasGuide === "0"'>
      <guide-page @closeGuide='closeGuideOper' />
    </div>
  </div>
</template>

<script>
import homeHeader from './components/home-header'
import homeFooter from './components/home-footer'
import guidePage from './components/guide-page'
export default {
  name: 'undergraduate-home-index',
  components: {
    homeHeader,
    homeFooter,
    guidePage
  },
  data () {
    return {
      // 本地存储的是否显示引导页标识
      hasGuide: '1'
    }
  },
  computed: {

  },
  mounted () {
    this.isShowGuide()
  },
  methods: {
    // 判断是否显示引导页
    isShowGuide () {
      if (this.$route.meta.menu === 'home') {
        this.hasGuide = localStorage.getItem('hasGuide') ? localStorage.getItem('hasGuide') : '0'
        console.log(this.hasGuide)
      }
    },
    // 存储引导
    closeGuideOper () {
      localStorage.setItem('hasGuide', '1')
    }
  }
}
</script>
<style lang='less' scoped>
.main-container {
  min-width: 1280px;
  min-height: 100vh;
  background: #f9fbff;
  position: relative;
  .home-main-con {
    padding: 100px 20px 160px;
  }
}
</style>
